import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  attachmentChipSx,
  attachmentDropLabelSx
} from './emailDialogShared';

/**
 * Drag-and-drop + file input zone (shared by ComposeDialog and ReplyDialog).
 */
export function MailAttachmentDropArea({
  fileInputKey,
  onFileChange,
  onDragOver,
  onDrop,
  extraSx = {}
}) {
  return (
    <Box sx={{ mt: 4 }}>
      <Box
        component="label"
        onDrop={onDrop}
        onDragOver={onDragOver}
        sx={{ ...attachmentDropLabelSx, ...extraSx }}
      >
        <Typography variant="body2" color="textSecondary">
          Drag and drop files here, or click to attach files.
        </Typography>
        <input
          key={fileInputKey}
          type="file"
          hidden
          multiple
          onChange={onFileChange}
        />
      </Box>
      <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 1 }}>
        Note: The email will be sent using our default template.
      </Typography>
    </Box>
  );
}

export function MailAttachmentChipList({ files, onRemove }) {
  if (!files?.length) return null;
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 2 }}>
      {files.map((file, index) => (
        <Box key={`${file.name}-${index}`} sx={attachmentChipSx}>
          <Typography variant="body2" sx={{ mr: 1 }}>
            {file.name}
          </Typography>
          <IconButton size="small" onClick={() => onRemove(index)}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      ))}
    </Box>
  );
}
